import { buildModelManager } from "../builder.js";
const DefaultNremtMedicalEvaluationSelection = {
  __typename: true,
  id: true,
  actualEndTime: true,
  actualStartTime: true,
  allergies: true,
  assessControlsMajorBleeding: true,
  assessesAirwayBreathing: true,
  assessesPulse: true,
  assessesSkinColor: true,
  assessmentAdequateVentilation: true,
  avpuAssessed: true,
  bloodPressureAssessed: true,
  candidateName: true,
  cardiovascularAssessment: true,
  chestAssessment: true,
  clarifyingQuestions: true,
  cohortId: true,
  comments: true,
  completedAt: true,
  completionTime: true,
  considersStabilization: true,
  createdAt: true,
  createdById: true,
  criticalCriteria: true,
  criticalFailures: true,
  criticalRationale: true,
  currentMedications: true,
  determinesResponsiveness: true,
  diagnosticBloodGlucose: true,
  evaluatesResponseToTreatments: true,
  evaluationDate: true,
  evaluationDuration: true,
  evaluationMetadata: true,
  eventsLeading: true,
  examinerName: true,
  examinerSignature: true,
  finalEvaluation: true,
  formVersion: true,
  giAssessment: true,
  historyOfPresentIllness: true,
  identifiesPriorityPatients: true,
  initiatesAppropriateOxygenTherapy: true,
  instructorEmail: true,
  instructorId: true,
  instructorNotes: true,
  integumentaryAssessment: true,
  liveScoring: true,
  mechanismOfInjuryIllness: true,
  modifiedFields: true,
  musculoskeletalAssessment: true,
  neurologicalAssessment: true,
  numberOfPatients: true,
  overallScore: true,
  pastIllnesses: true,
  pastPertinentHistory: true,
  performanceRatings: true,
  psychologicalSocialAssessment: true,
  pulmonaryAssessment: true,
  pulseAssessed: true,
  radiationAssessment: true,
  repeatsInitialAssessment: true,
  repeatsSecondaryAssessment: true,
  repeatsVitalSigns: true,
  reproductiveAssessment: true,
  respiratoryRateQualityAssessed: true,
  scenarioId: true,
  scenarioNumber: true,
  scenarioRunId: true,
  sceneIsSafe: true,
  severityAssessment: true,
  shareTokenId: true,
  simulationSessionId: true,
  statesFieldImpression: true,
  status: true,
  studentEmail: true,
  studentId: true,
  submittedViaEmail: true,
  timeAssessment: true,
  updatedAt: true,
  verbalizesGeneralImpression: true,
  verbalizesToTransport: true
};
const modelApiIdentifier = "nremtMedicalEvaluation";
const pluralModelApiIdentifier = "nremtMedicalEvaluations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultNremtMedicalEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultNremtMedicalEvaluationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultNremtMedicalEvaluationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultNremtMedicalEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultNremtMedicalEvaluationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultNremtMedicalEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultNremtMedicalEvaluationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createNremtMedicalEvaluation",
    operationReturnType: "CreateNremtMedicalEvaluation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      nremtMedicalEvaluation: { required: false, type: "CreateNremtMedicalEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultNremtMedicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateNremtMedicalEvaluations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateNremtMedicalEvaluationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultNremtMedicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "updateNremtMedicalEvaluation",
    operationReturnType: "UpdateNremtMedicalEvaluation",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      nremtMedicalEvaluation: { required: false, type: "UpdateNremtMedicalEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultNremtMedicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateNremtMedicalEvaluations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateNremtMedicalEvaluationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultNremtMedicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "deleteNremtMedicalEvaluation",
    operationReturnType: "DeleteNremtMedicalEvaluation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteNremtMedicalEvaluations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertNremtMedicalEvaluation",
    operationReturnType: "UpsertNremtMedicalEvaluation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      nremtMedicalEvaluation: { required: false, type: "UpsertNremtMedicalEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateNremtMedicalEvaluationResult": { hasReturnType: false },
      "... on UpdateNremtMedicalEvaluationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultNremtMedicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertNremtMedicalEvaluations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertNremtMedicalEvaluationsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultNremtMedicalEvaluationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "nremtMedicalEvaluationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const NremtMedicalEvaluationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultNremtMedicalEvaluationSelection,
  operations
);
export {
  DefaultNremtMedicalEvaluationSelection,
  NremtMedicalEvaluationManager
};
//# sourceMappingURL=NremtMedicalEvaluation.js.map
